/**
 * Copyright (C) 2019 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

export const LuiPositioningMixin = Superclass => class extends Superclass {
  getRelativePosition(element) {
    const componentPosition = this.getBoundingClientRect()
    const elementPosition = element.getBoundingClientRect()

    const componentStyle = window.getComputedStyle(this)
    const componentPaddingTop = parseInt(componentStyle.paddingTop, 10) || 0
    const componentPaddingLeft = parseInt(componentStyle.paddingLeft, 10) || 0

    return {
      top: elementPosition.top - componentPosition.top - componentPaddingTop,
      left: elementPosition.left - componentPosition.left - componentPaddingLeft,
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-base/lui-positioning-mixin.js
// module id = 9
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38